module.exports = __webpack_public_path__ + "media/images/brand/footer-slogan-2d9cfbf8bc629be4ebe12952a440d99f.png";